import React, { Component } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import { setObj } from "../../actions/noteActions";
import Breadcrumb from "../../components/Breadcrumb";
import ImportData from "../../components/ImportData";
import ProtectedRoute from "../../components/ProtectedRoute";
import URL from "../../config/api";
import axios from "../../config/axios";

import "./style.css";

class Import extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      // selected: 0,
      sent: [],
      // processed: [],
      // logs: [],
      group: this.props.general.active_roles.group_id,
      processing: null,
      file: null, // Novo estado para armazenar o arquivo
      dragging: false, // Estado para controlar o arrastar e soltar
      error: "" // Estado para exibir erros
      // sending: false
    };

    this.fileInputRef = React.createRef();
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    this.handleSentFiles();
    this.changeBackgroundColor();
  }

  handleDragOver = e => {
    e.preventDefault();
    this.setState({ dragging: true });
  };

  handleDragLeave = () => {
    this.setState({ dragging: false });
  };

  handleInputChange = e => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.name.endsWith(".xlsx")) {
      this.setState({ file: selectedFile, error: "" });
    } else {
      this.setState({
        error: "Arquivo incompatível. Por favor envie um arquivo do tipo xlsx."
      });
      toastr.error(
        "Arquivo incompatível",
        "Por favor envie um arquivo do tipo xlsx."
      );
    }
  };

  handleSentFiles() {
    this.setState({ loading: true });
    axios
      .get(`${URL.api}import/sent`, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState({
            sent: resp.data.data.sort(this.sortFiles),
            loading: false
          });
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  onFilesAdded = () => {
    // this.setState({ sending: true });
    let files;
    if (this.state.file) {
      files = [this.state.file];
    } else {
      files = Array.from(this.fileInputRef.current.files).filter(file =>
        file.name.endsWith(".xlsx")
      );
    }
    const formData = new FormData();

    for (let i = 0; i < files.length; i++) {
      formData.append(`file${i}`, files[i]);
    }

    axios
      .post(`${URL.api}import/send`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${this.props.user.token}`
        }
      })
      .then(
        resp => {
          this.handleSentFiles();
          this.handleCancel();
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  };

  handleDrop = e => {
    e.preventDefault();
    this.setState({ dragging: false });

    const droppedFile = e.dataTransfer.files[0];

    if (droppedFile && droppedFile.name.endsWith(".xlsx")) {
      this.setState({ file: droppedFile, error: "" });
      this.fileInputRef.current.files = e.dataTransfer.files;
    } else {
      this.setState({
        error: "Arquivo incompatível. Por favor envie um arquivo do tipo xlsx."
      });
      toastr.error(
        "Arquivo incompatível",
        "Por favor envie um arquivo do tipo xlsx."
      );
    }
  };

  removeSent = filename => {
    axios
      .post(
        `${URL.api}import/delete`,
        { name: filename },
        {
          headers: {
            Authorization: `Bearer ${this.props.user.token}`
          }
        }
      )
      .then(
        resp => {
          this.handleSentFiles();
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  };

  async processFiles() {
    if (this.state.group === null) {
      toastr.warning(
        "Selecione um grupo",
        "Para continuar, escolha um grupo para processar seus dados"
      );
      return;
    }

    for (const file of this.state.sent) {
      try {
        this.setState({ processing: file.original_name });

        await axios.post(
          `${URL.api}import/process/${file.original_name}`,
          { group_id: this.state.group },
          { headers: { Authorization: `Bearer ${this.props.user.token}` } }
        );

        this.setState(state => {
          const sent = state.sent.filter(
            item => item.original_name !== file.original_name
          );

          return { sent };
        });
      } catch (error) {
        this.error(error.response.statusText);
      }
    }

    this.setState({ processing: null });
  }

  handleDropzoneClick = () => {
    this.fileInputRef.current.click();
  };

  handleCancel = () => {
    this.setState({ file: null, error: "" });
    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = "";
    }
  };

  error = response => {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  };

  handleDownload = () => {
    const link = document.createElement("a");
    const urlLink =
      "https://back.educandus.com.br/uploads/sheets/1723646940-importação_de_alunos_educandus.xlsx";
    link.href = urlLink;
    link.download = "importacao_de_alunos_educandus.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  changeBackgroundColor = () => {
    const container = document.querySelector(".container-fluid");
    if (container) {
      container.style.backgroundColor = "#F0F4F8";
    }
  };

  render() {
    const { loading, sent, dragging, file, error, processing } = this.state;

    return (
      <>
        <Breadcrumb current={this.props.currentRoute} />
        <ImportData />
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ logout, setObj }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Import);
